import { ImgHTMLAttributes } from "react";
import { useAssetFileQuery } from "@/hooks/assets";
import Image from "@ingka/image";
import Skeleton from "@ingka/skeleton";

type AuthenticatedImageProps = {
  assetId: number;
  thumbnail?: boolean;
} & ImgHTMLAttributes<HTMLImageElement>;

export const AuthenticatedImage = ({
  assetId,
  thumbnail,
  ...rest
}: AuthenticatedImageProps) => {
  const { data } = useAssetFileQuery(assetId, thumbnail);
  return data ? (
    <Image {...rest} src={data.blobUrl} alt={`Image for asset ${assetId}`} />
  ) : (
    <Skeleton className={rest.className} />
  );
};
